<template>
  <div class="icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      viewBox="0 0 512 512"
    >
      <title>Close</title>
      <path
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M368 368L144 144M368 144L144 368"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Close",
};
</script>

<style scoped lang="scss">
.icon {
  width: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/icons/CloseOutline.vue